import { get, put } from "@/shared/utils/fetchApi";

export interface AssistantConfig {
  BaseUrl?: string;
  TranscriptEngine?: string;
  ProdgyBack?: {
    BaseUrl?: string;
    ApiKey?: string;
    AgentName?: string;
  };
  Calendar?: {
    Enabled?: boolean;
    Mailbox?: string;
    /** Paces the calendar read cycle — the queue is derived from this calendar. */
    PollIntervalMinutes?: number;
    /** Days ahead of now the calendar is read. */
    HorizonDays?: number;
    Graph?: {
      TenantId?: string;
      ClientId?: string;
      ClientSecret?: string;
    };
  };
  GraphCommsBot?: {
    Name?: string;
    BaseUrl?: string;
    MaxWaitMinutes?: number;
    CertificateThumbprint?: string;
  };
  LogsApi?: {
    ApiKey?: string;
    LogsDirectory?: string;
  };
  AzureAd?: {
    TenantId?: string;
    ClientId?: string;
    ClientSecret?: string;
    BotUserId?: string;
  };
}

export interface SaveConfigResponse {
  success: boolean;
  message: string;
}

export class ConfigService {
  static async getConfig(): Promise<AssistantConfig> {
    return get<AssistantConfig>("/assistant/config");
  }

  static async updateConfig(
    config: AssistantConfig,
  ): Promise<SaveConfigResponse> {
    return put<SaveConfigResponse>("/assistant/config", config);
  }
}
